import { render } from "./SendForm.vue?vue&type=template&id=7e758d88&lang=pug"
import script from "./SendForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SendForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__